var exports = {
  "K": "RecipientRemoveMessage.module__icon___d1B4S1",
};

module.exports = exports;
